module.exports = __webpack_public_path__ + "static/img/icon-ok.a87ec91c.svg";